import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../shared/shared.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {DtoBranchUser} from "../../shared/models/DtoBranchUser";
import {DtoCashregItem} from "../cashreg-week/models/DtoCashregItem";
import {CashregDayService} from "./cashreg-day.service";


@Component({
    selector: 'app-administration-cashreg-day',
    template: require('./cashreg-day.component.html'),
    styles: [require('./cashreg-day.component.css')]
})

@AutoUnsubscribe()
export class CashregDayComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    filterHeaderConfig: PageHeaderBarConfig = {
        title: 'INSTELLINGEN',
        buttonDefinition: [
            {
                description: 'BEKIJKEN',
                isSmall: false,
                clickEventType: 'search'
            }
        ]
    };
    pshbConfig: PageSubheaderBarConfig = {
        title: 'DAGSTAAT',
        buttonDefinition: [
            {
                description: 'EXCEL',
                isSmall: false,
                clickEventType: 'excel'
            }
        ]
    };
    filterForm: FormGroup = this.fb.group({
        checkDate: this.ss.getCurrentDate()
    });
    branches: DtoBranchUser[];
    data: DtoCashregItem[];
    excelFilename: string;
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '240px'
        },
        {
            key: 'branches[0].amount',
            label: 'Hoofdvestiging',
            type: 'currency',
            width: `${this.ss.CalculateColumnWidth('Hoofdvestiging')}px`,
            format: '{0:n2}'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ds: CashregDayService,
                private ss: SharedService,
                private sds: SharedDataService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'administratie', isLastStep: false },
            { text: 'dagstaat', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');

        this.sds.getBranches().subscribe((res: DtoBranchUser[]) => {
            this.branches = res;
            for (let i = 0; i < this.branches.length; i++) {
                this.columnDefinition.push({
                    key: `branches[${i + 1}].amount`,
                    label: this.branches[i].companyName,
                    type: 'currency',
                    width: `${this.ss.CalculateColumnWidth(this.branches[i].companyName)}px`,
                    format: '{0:n2}'
                });
            }
            setTimeout(() => {
                this.loadData();
            });
        });
    }

    loadData() {
        this.excelFilename = `dagstaat - ${this.ss.formatDate(this.filterForm.get('checkDate').value, 'dd-MM-yyyy')}.xlsx`;
        this.ds.getCashregByDate(this.filterForm.get('checkDate').value).subscribe((res: DtoCashregItem[]) => {
            this.data = res;
            this.grid.showData(this.data);
            this.grid.fitColumns();
        });
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        }
    }

    pshbBtnClicked(event) {
        if (event == 'excel') {
            this.grid.saveAsExcel();
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/administration/cashreg-day/cashreg-day.component.ts